// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type FetchEmailListsParams = {
    authToken: string,
    deployment: string,
};

type PostSubscribeToEmailListParams = {
    authToken: string,
    code: string,
    deployment: string,
};

type PostUnsubscribeFromEmailListParams = {
    authToken: string,
    code: string,
    deployment: string,
};

export default {
    fetchEmailLists: ({ authToken, deployment }: FetchEmailListsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<ITEM-API>profile/lists' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postSubscribeToEmailList: ({ authToken, code, deployment }: PostSubscribeToEmailListParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>profile/subscribe' });
            request.send({ code, source: 'web' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postUnsubscribeFromEmailList: ({ authToken, code, deployment }: PostUnsubscribeFromEmailListParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>profile/unsubscribe' });
            request.send({ code, source: 'web' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
